import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/frontend/src/app/dashboard/DashboardClient.tsx");
